<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false"
             :show-close="false" width="50%" custom-class="custom-dialog-class">
    <template #title="title">
      <div class="custom-dialog-header">
        <div class="title">
          <span></span>
          <span>设置课表</span>
        </div>
        <div class="close">
          <img src="../../assets/images/nanjingdataboard/close.png" alt="" @click="cancel">
        </div>
      </div>
    </template>
    <template #default>
      <div class="dialog-body">
        <div class="left">
          <div class="left-top">
            <div class="classroom-list-title">
              <span>教室列表</span>
            </div>
            <div class="left-top-list">
              <ul>
                <li v-for="(item,index) in classroomList" :key="index" @click="findCurriculumData(item,index)"
                    :class="activeClassroomInfo.id === item.id ? 'li-active':''">
                  <span>{{ item.title }}</span>
                  <img src="../../assets/images/nanjingdataboard/edit.png" alt=""
                       @click.stop="addOrEditClassroom(true,item)">
                  <i class="el-icon-error classroom-delete" @click.stop="deleteClassroom(item)"/>
                </li>
                <li class="add-classroom" @click.stop="addOrEditClassroom(false)"><span>+添加教室</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="right">
          <el-table :data="tableDataList" v-if="activeClassroomInfo.id && tableDataList.length > 0"
                    style="width: 100% ;float: left">
            <el-table-column type="index" label="节数" align="center" width="100"/>
            <el-table-column prop="startTime" label="开始时间" align="center">
              <template slot-scope="scope">
                <el-popover placement="top" :ref="`tablePopoverStart${scope.$index}Ref`" width="160"
                            v-model="scope.row.startPopoverVisible"
                            popper-class="table-custom-popover">
                  <el-time-picker v-model="scope.row.startTime"
                                  placeholder="开始时间" size="mini"
                                  format="HH:mm"
                                  value-format="HH:mm"
                                  @change="checkTime(scope.row,'start')" :ref="`tablePickerStart${scope.$index}Ref`"
                                  clearable
                                  :append-to-body="zoom <= 1" :popper-class="zoom >1 ?'custom-time-picker':''"/>
                  <span slot="reference" class="el-table-custom-span" :title="scope.row.startTime"
                        v-if="scope.row.startTime"
                        @click="handleClickPopover(`tablePopoverStart${scope.$index}Ref`)">{{
                      scope.row.startTime
                    }}</span>
                  <span slot="reference" class="el-table-custom-span" title="点击设置" v-else
                        @click="handleClickPopover(`tablePopoverStart${scope.$index}Ref`)">点击设置</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间" align="center">
              <template slot-scope="scope">
                <el-popover placement="top" :ref="`tablePopoverEnd${scope.$index}Ref`" width="160"
                            v-model="scope.row.endPopoverVisible"
                            popper-class="table-custom-popover">
                  <el-time-picker v-model="scope.row.endTime"
                                  placeholder="结束时间" size="mini"
                                  format="HH:mm"
                                  value-format="HH:mm"
                                  @change="checkTime(scope.row,'end')" :ref="`tablePickerEnd${scope.$index}Ref`"
                                  clearable
                                  :append-to-body="zoom <= 1" :popper-class="zoom >1 ?'custom-time-picker':''"/>
                  <span slot="reference" class="el-table-custom-span" :title="scope.row.endTime"
                        v-if="scope.row.endTime" @click="handleClickPopover(`tablePopoverEnd${scope.$index}Ref`)">{{
                      scope.row.endTime
                    }}</span>
                  <span slot="reference" class="el-table-custom-span" title="点击设置" v-else
                        @click="handleClickPopover(`tablePopoverEnd${scope.$index}Ref`)">点击设置</span>
                </el-popover>
              </template>
            </el-table-column>
            <!--            <el-table-column prop="monday" label="周一" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.monday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverMonday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.monday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.monday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,1)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectMonday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Monday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.monday.classId" :label="scope.row.monday.className"-->
            <!--                                   :value="scope.row.monday.classId" v-if="optionNotFound(scope.row.monday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.monday.subjectId" @change="changeSubject(scope.row,1)" size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectMonday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Monday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.monday.subjectName"-->
            <!--                        v-if="scope.row.monday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.monday.classId); handleClickWeekPopover(`tablePopoverMonday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.monday.className }}-->
            <!--                    <br/>-->
            <!--                    {{ scope.row.monday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.monday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverMonday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column prop="tuesday" label="周二" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.tuesday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverTuesday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.tuesday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.tuesday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,2)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectTuesday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Tuesday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.tuesday.classId" :label="scope.row.tuesday.className"-->
            <!--                                   :value="scope.row.tuesday.classId" v-if="optionNotFound(scope.row.tuesday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.tuesday.subjectId" @change="changeSubject(scope.row,2)" size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectTuesday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Tuesday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.tuesday.subjectName"-->
            <!--                        v-if="scope.row.tuesday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.tuesday.classId);handleClickWeekPopover(`tablePopoverTuesday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.tuesday.className }}-->
            <!--                    <br/>-->
            <!--                    {{ scope.row.tuesday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.tuesday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverTuesday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column prop="wednesday" label="周三" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.wednesday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverWednesday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.wednesday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.wednesday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,3)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectWednesday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Wednesday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.wednesday.subjectId" @change="changeSubject(scope.row,3)"-->
            <!--                                 size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectWednesday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Wednesday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.wednesday.classId" :label="scope.row.wednesday.className"-->
            <!--                                   :value="scope.row.wednesday.classId"-->
            <!--                                   v-if="optionNotFound(scope.row.wednesday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.wednesday.subjectName"-->
            <!--                        v-if="scope.row.wednesday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.wednesday.classId);handleClickWeekPopover(`tablePopoverWednesday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.wednesday.className }}-->
            <!--                    <br/>-->
            <!--                    {{ scope.row.wednesday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.wednesday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverWednesday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column prop="thursday" label="周四" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.thursday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverThursday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.thursday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.thursday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,4)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectThursday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Thursday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.thursday.classId" :label="scope.row.thursday.className"-->
            <!--                                   :value="scope.row.thursday.classId"-->
            <!--                                   v-if="optionNotFound(scope.row.thursday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.thursday.subjectId" @change="changeSubject(scope.row,4)" size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectThursday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Thursday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.thursday.subjectName"-->
            <!--                        v-if="scope.row.thursday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.thursday.classId);handleClickWeekPopover(`tablePopoverThursday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.thursday.className }}-->
            <!--                    <br/>-->
            <!--                    {{ scope.row.thursday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.thursday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverThursday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column prop="friday" label="周五" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.friday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverFriday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.friday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.friday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,5)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectFriday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Friday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.friday.classId" :label="scope.row.friday.className"-->
            <!--                                   :value="scope.row.friday.classId" v-if="optionNotFound(scope.row.friday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.friday.subjectId" @change="changeSubject(scope.row,5)" size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectFriday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Friday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.friday.subjectName"-->
            <!--                        v-if="scope.row.friday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.friday.classId);handleClickWeekPopover(`tablePopoverFriday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.friday.className }}-->
            <!--                    <br/>-->
            <!--                    {{ scope.row.friday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.friday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverFriday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column prop="saturday" label="周六" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.saturday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverSaturday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.saturday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.saturday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,6)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectSaturday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Saturday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.saturday.subjectId" @change="changeSubject(scope.row,6)" size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectSaturday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Saturday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.saturday.classId" :label="scope.row.saturday.className"-->
            <!--                                   :value="scope.row.saturday.classId"-->
            <!--                                   v-if="optionNotFound(scope.row.saturday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.saturday.subjectName"-->
            <!--                        v-if="scope.row.saturday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.saturday.classId);handleClickWeekPopover(`tablePopoverSaturday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.saturday.className }}-->
            <!--                    <br/>-->
            <!--                    {{ scope.row.saturday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.saturday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverSaturday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column prop="sunday" label="周日" align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-popover placement="top" v-model="scope.row.sunday.popoverVisible"-->
            <!--                            popper-class="table-custom-select-popover" :ref="`tablePopoverSunday${scope.$index}Ref`">-->
            <!--                  <el-form :model="scope.row.sunday" label-width="80px">-->
            <!--                    <el-form-item label="班级：">-->
            <!--                      <el-select v-model="scope.row.sunday.classId" size="mini" :popper-append-to-body="true"-->
            <!--                                 placeholder="请选择班级" @change="changeClass(scope.row,7)" clearable-->
            <!--                                 v-el-select-loadmore="loadMore" :ref="`formClassSelectSunday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormClassSelect(`Sunday${scope.$index}`)">-->
            <!--                        <el-option :key="scope.row.sunday.classId" :label="scope.row.sunday.className"-->
            <!--                                   :value="scope.row.sunday.classId" v-if="optionNotFound(scope.row.sunday.classId)"/>-->
            <!--                        <el-option-->
            <!--                            v-for="item in classList"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.grade_name + item.class_name"-->
            <!--                            :value="item.id"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                    <el-form-item label="学科：">-->
            <!--                      <el-select v-model="scope.row.sunday.subjectId" @change="changeSubject(scope.row,7)" size="mini"-->
            <!--                                 :popper-append-to-body="true" placeholder="请选择学科" clearable-->
            <!--                                 :ref="`formSubjectSelectSunday${scope.$index}Ref`"-->
            <!--                                 @focus="focusFormSubjectSelect(`Sunday${scope.$index}`)">-->
            <!--                        <el-option-->
            <!--                            v-for="item in substituteTeaList"-->
            <!--                            :key="item.subjectid"-->
            <!--                            :label="item.subject_name"-->
            <!--                            :value="item.subjectid"/>-->
            <!--                      </el-select>-->
            <!--                    </el-form-item>-->
            <!--                  </el-form>-->
            <!--                  <span slot="reference" class="el-table-custom-span" :title="scope.row.sunday.subjectName"-->
            <!--                        v-if="scope.row.sunday.subjectId"-->
            <!--                        @click="getTeacherList(scope.row.sunday.classId);handleClickWeekPopover(`tablePopoverSunday${scope.$index}Ref`)">-->
            <!--                    {{ scope.row.sunday.className }}-->
            <!--                    <br/>{{ scope.row.sunday.subjectName }}-->
            <!--                  </span>-->
            <!--                  <span slot="reference" class="el-table-custom-span add-span" title="+"-->
            <!--                        v-if="!scope.row.sunday.subjectId"-->
            <!--                        @click="handleClickWeekPopover(`tablePopoverSunday${scope.$index}Ref`)">+</span>-->
            <!--                </el-popover>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <div style="width: 100%;height: 20px;font-size: 14px;color: #8BA4E7;">
                <span style="cursor: pointer" @click="clearRow(scope.row)"
                      v-show="isRowExistData(scope.row)">清空</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="no-data" v-else>
            <span>点击教室，设置课表</span>
          </div>
        </div>
      </div>
      <!-- 添加教室弹框 -->
      <el-dialog :visible.sync="classroomDialogVisible"
                 width="22%" :close-on-click-modal="false" :show-close="false" custom-class="classroom-dialog"
                 append-to-body>
        <template #title="title">
          <div class="classroom-dialog-header">
            <div class="title">
              <span></span>
              <span>{{ classroomDialogUpdate ? '修改教室' : '添加教室' }}</span>
            </div>
            <div class="close">
              <img src="../../assets/images/nanjingdataboard/close.png" alt="" @click="closeClassroom">
            </div>
          </div>
        </template>
        <template #default>
          <div class="classroom-dialog-body">
            <el-form :model="classroomForm" :rules="classroomFormRules" ref="classroomFormRef" label-width="120px">
              <el-form-item prop="title" label="教室名称: ">
                <el-input v-model="classroomForm.title" placeholder="请输入教室名称" clearable/>
              </el-form-item>
              <el-form-item prop="classId" label="绑定班级: ">
                <el-select v-model="classroomForm.classId" placeholder="请选择绑定班级" clearable
                           :popper-append-to-body="false" popper-class="bind-class-select-dropdown">
                  <!--                  <el-option key="1" label="测试教室" value="1"/>-->
                  <el-option
                      v-for="item in customBindClassList"
                      :key="item.classId"
                      :label="item.gradeName + item.className"
                      :value="item.classId" :disabled="item.disabled"/>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template #footer>
          <div class="classroom-dialog-footer">
            <el-button type="primary" size="small" @click="saveClassroom">确 定</el-button>
            <el-button size="small" plain link @click="closeClassroom">取 消</el-button>
          </div>
        </template>
      </el-dialog>
    </template>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" size="small" @click="submitData">保 存</el-button>
        <el-button size="small" plain link @click="cancel">取 消</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import {
  delClassCourseTableApi, delClassRoomApi,
  getClassCourseTableListApi,
  getClassListApi,
  getTeacherListByClassId,
  saveClassRoomApi,
  setClassCourseTableApi
} from "../../service/bigDataApi";

export default {
  name: 'curriculum-setting',
  props: {
    // 学校id
    schoolId: {
      type: String,
      default: '0'
    },
    // 绑定班级列表
    bindClassList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 教室列表
    classroomList: {
      type: Array,
      default: () => {
        return []
      }
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  emits: ['refresh-class-course-state', 'refresh-classroom-list'],
  data() {
    return {
      dialogVisible: false,
      // 屏幕高度
      screenHeight: 0,
      // 表格数据
      tableDataList: [],
      // 自定义年级id
      gradeId: '-1,-1',
      // 删除的课表id
      delIds: '',
      // 激活的教室信息
      activeClassroomInfo: {
        // 教室id
        id: '',
        // 教师名称
        title: '',
        // 学校id
        schoolId: '',
        // 班级id
        classId: '',
      },
      // 教室弹框显示状态
      classroomDialogVisible: false,
      // 教室弹框添加或修改
      classroomDialogUpdate: false,
      // 教室表单
      classroomForm: {
        // 教室id
        id: '',
        // 教师名称
        title: '未来教室',
        // 学校id
        schoolId: '',
        // 班级id
        classId: ''
      },
      // 规则
      classroomFormRules: {
        title: [{required: true, message: '请输入教室名称', trigger: 'blur'}],
        classId: [{required: true, message: '请选择绑定班级', trigger: 'blur'}],
      },
      // 班级列表
      classList: [],
      // 授课教师列表
      substituteTeaList: [],
      // 班级列表查询参数
      classParams: {
        schoolId: '',
        // 班级类型（1：行政班，3：分层班-1全部班级） 默认-1
        classType: 1,
        // 当前第几页
        page: 1,
        // 每页多少条(最大限制100)
        limit: 10,
        // 总页数
        pageCount: 0,
        // 总条数
        totalRows: 0,
        //最后一次加载之后，不再加载
        stopLoading: false,
      }
    }
  },
  computed: {
    // 自定义绑定班级列表实现禁用选项
    customBindClassList: function () {
      let tmpClassroomList = JSON.stringify(this.classroomList)
      let filterList = JSON.parse(tmpClassroomList).filter((item) => !(item.id === this.classroomForm.id && this.classroomForm.classId.length === 0))
      let classIds = filterList.map(item => item.classId);
      return this.bindClassList.map((item) => {
        item.disabled = !!classIds.includes(item.classId);
        return item;
      })
    },
  },
  mounted() {
    //获取屏幕高度
    this.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  },
  // 在页面注销前，将点击事件给移除
  beforeDestroy() {
  },
  methods: {
    // 显示弹框
    showDialog() {
      this.dialogVisible = true;
      this.tableDataList = [
        {
          schoolId: this.schoolId,
          num: 0,
          classroomId: this.activeClassroomInfo.id,
          roomClassId: this.activeClassroomInfo.classId,
          startTime: '',
          endTime: '',
          monday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          tuesday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          wednesday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          thursday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          friday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          saturday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          sunday: {
            id: 0,
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            teaId: '',
            teaName: '',
            popoverVisible: false
          },
          startPopoverVisible: false,
          endPopoverVisible: false,
        }
      ]
      this.activeClassroomInfo = {
        id: '',
        title: '',
        schoolId: '',
        classId: '',
      }
      this.getClassList()
      if (this.classroomList.length > 0) {
        this.findCurriculumData(this.classroomList[0], 0)
      }
    },

    // 获取课表数据
    findCurriculumData(item, index) {
      this.activeClassroomInfo = item;

      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
        classRoomId: item.id
      }

      this.getClassCourseTableList(params)
    },

    // 获取课表数据
    async getClassCourseTableList(params) {
      await getClassCourseTableListApi(params).then((res) => {
        if (res.length > 0) {
          // 新数据格式
          let newData = []
          let nums = res.map((item) => {
            let tmp = {
              id: 0,
              schoolId: item.schoolId,
              num: item.num,
              classroomId: item.classroomId,
              roomClassId: item.roomClassId,
              startTime: item.startTime,
              endTime: item.endTime,
              startPopoverVisible: false,
              endPopoverVisible: false,
              monday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
              tuesday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
              wednesday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
              thursday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
              friday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
              saturday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
              sunday: {
                id: 0,
                classId: '',
                className: '',
                subjectId: '',
                subjectName: '',
                teaId: '',
                teaName: '',
                popoverVisible: false,
              },
            }
            return JSON.stringify(tmp)
          })
          let newNums = new Set(nums)
          newNums.forEach((json) => {
            let parseJson = JSON.parse(json)
            res.forEach((item) => {
              if (parseJson.schoolId === item.schoolId && parseJson.num === item.num && parseJson.classRoomId === item.classRoomId && parseJson.roomClassId === item.roomClassId && parseJson.startTime === item.startTime && parseJson.endTime === parseJson.endTime) {
                parseJson.id = item.id
                if (item.week === 1) {
                  parseJson.monday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                } else if (item.week === 2) {
                  parseJson.tuesday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                } else if (item.week === 3) {
                  parseJson.wednesday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                } else if (item.week === 4) {
                  parseJson.thursday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                } else if (item.week === 5) {
                  parseJson.friday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                } else if (item.week === 6) {
                  parseJson.saturday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                } else if (item.week === 7) {
                  parseJson.sunday = {
                    id: item.id,
                    classId: item.classId,
                    className: item.className,
                    subjectId: item.subjectId,
                    subjectName: item.subjectName,
                    teaId: item.teaId,
                    teaName: item.teaName,
                    popoverVisible: false,
                  }
                }
              }
            })
            newData.push(parseJson)
          })
          this.tableDataList = newData
        } else {
          this.tableDataList = []
          this.addOrEdit()
        }
      }).catch(function (error) {
        this.$message.error(error.message);
      })
    },

    // 添加一行或多行
    addOrEdit() {
      const tmp = {
        id: 0,
        schoolId: this.schoolId,
        num: 0,
        classroomId: this.activeClassroomInfo.id,
        roomClassId: this.activeClassroomInfo.classId,
        startTime: '',
        endTime: '',
        monday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        tuesday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        wednesday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        thursday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        friday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        saturday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        sunday: {
          id: 0,
          classId: '',
          className: '',
          subjectId: '',
          subjectName: '',
          teaId: '',
          teaName: '',
          popoverVisible: false
        },
        startPopoverVisible: false,
        endPopoverVisible: false,
      }
      this.tableDataList.push(tmp)
    },

    // 检测行是否填写
    isRowFilled(row) {
      // 检查行是否填写，这里简单判断是否有内容
      if (row) {
        return row.startTime && row.endTime
      }
    },

    // 时间检测
    checkTime(row, type) {
      if (row.startTime && row.endTime) {
        if (type === 'start' && row.startTime > row.endTime) {
          this.$message.warning('开始时间不能大于结束时间')
          row.endTime = ''
        }
        if (type === 'end' && row.endTime < row.startTime) {
          this.$message.warning('结束时间不能小于开始时间')
          row.startTime = ''
        }
      }
      if (type === 'start') {
        if (row.startTime == null) {
          row.startTime = ''
        }
        row.startPopoverVisible = false
      } else if (type === 'end') {
        if (row.endTime == null) {
          row.endTime = ''
        }
        row.endPopoverVisible = false
      }
    },

    // 选择班级
    changeClass(row, type) {
      let classId = ''
      switch (type) {
        case 1:
          row.monday.subjectId = ''
          row.monday.subjectName = ''
          row.monday.teaId = ''
          row.monday.teaName = ''
          if (row.monday.classId !== '') {
            let tmp1 = this.classList.find(item => item.id === row.monday.classId)
            row.monday.className = tmp1.grade_name + tmp1.class_name
            classId = row.monday.classId
          } else {
            row.monday.className = ''
          }
          break;
        case 2:
          row.tuesday.subjectId = ''
          row.tuesday.subjectName = ''
          row.tuesday.teaId = ''
          row.tuesday.teaName = ''
          if (row.tuesday.classId !== '') {
            let tmp2 = this.classList.find(item => item.id === row.tuesday.classId)
            row.tuesday.className = tmp2.grade_name + tmp2.class_name
            classId = row.tuesday.classId
          } else {
            row.tuesday.className = ''
          }
          break;
        case 3:
          row.wednesday.subjectId = ''
          row.wednesday.subjectName = ''
          row.wednesday.teaId = ''
          row.wednesday.teaName = ''
          if (row.wednesday.classId !== '') {
            let tmp3 = this.classList.find(item => item.id === row.wednesday.classId)
            row.wednesday.className = tmp3.grade_name + tmp3.class_name
            classId = row.wednesday.classId
          } else {
            row.wednesday.className = ''
          }
          break;
        case 4:
          row.thursday.subjectId = ''
          row.thursday.subjectName = ''
          row.thursday.teaId = ''
          row.thursday.teaName = ''
          if (row.thursday.classId !== '') {
            let tmp4 = this.classList.find(item => item.id === row.thursday.classId)
            row.thursday.className = tmp4.grade_name + tmp4.class_name
            classId = row.thursday.classId
          } else {
            row.thursday.className = ''
          }
          break;
        case 5:
          row.friday.subjectId = ''
          row.friday.subjectName = ''
          row.friday.teaId = ''
          row.friday.teaName = ''
          if (row.friday.classId !== '') {
            let tmp5 = this.classList.find(item => item.id === row.friday.classId)
            row.friday.className = tmp5.grade_name + tmp5.class_name
            classId = row.friday.classId
          } else {
            row.friday.className = ''
          }
          break;
        case 6:
          row.saturday.subjectId = ''
          row.saturday.subjectName = ''
          row.saturday.teaId = ''
          row.saturday.teaName = ''
          if (row.saturday.classId !== '') {
            let tmp6 = this.classList.find(item => item.id === row.saturday.classId)
            row.saturday.className = tmp6.grade_name + tmp6.class_name
            classId = row.saturday.classId
          } else {
            row.saturday.className = ''
          }
          break;
        case 7:
          row.sunday.subjectId = ''
          row.sunday.subjectName = ''
          row.sunday.teaId = ''
          row.sunday.teaName = ''
          if (row.sunday.classId !== '') {
            let tmp7 = this.classList.find(item => item.id === row.sunday.classId)
            row.sunday.className = tmp7.grade_name + tmp7.class_name
            classId = row.sunday.classId
          } else {
            row.sunday.className = ''
          }
          break;
      }
      this.getTeacherList(classId)
    },

    // 选择学科
    changeSubject(row, type) {
      switch (type) {
        case 1:
          if (row.monday.subjectId !== '') {
            let tmp1 = this.substituteTeaList.find(item => item.subjectid === row.monday.subjectId)
            row.monday.subjectName = tmp1.subject_name
            row.monday.teaId = tmp1.userid
            row.monday.teaName = tmp1.realname
            row.monday.popoverVisible = false
          } else {
            row.monday.subjectName = ''
            row.monday.teaId = ''
            row.monday.teaName = ''
          }
          break;
        case 2:
          if (row.tuesday.subjectId !== '') {
            let tmp2 = this.substituteTeaList.find(item => item.subjectid === row.tuesday.subjectId)
            row.tuesday.subjectName = tmp2.subject_name
            row.tuesday.teaId = tmp2.userid
            row.tuesday.teaName = tmp2.realname
            row.tuesday.popoverVisible = false
          } else {
            row.tuesday.subjectName = ''
            row.tuesday.teaId = ''
            row.tuesday.teaName = ''
          }
          break;
        case 3:
          if (row.wednesday.subjectId !== '') {
            let tmp3 = this.substituteTeaList.find(item => item.subjectid === row.wednesday.subjectId)
            row.wednesday.subjectName = tmp3.subject_name
            row.wednesday.teaId = tmp3.userid
            row.wednesday.teaName = tmp3.realname
            row.wednesday.popoverVisible = false
          } else {
            row.wednesday.subjectName = ''
            row.wednesday.teaId = ''
            row.wednesday.teaName = ''
          }
          break;
        case 4:
          if (row.thursday.subjectId !== '') {
            let tmp4 = this.substituteTeaList.find(item => item.subjectid === row.thursday.subjectId)
            row.thursday.subjectName = tmp4.subject_name
            row.thursday.teaId = tmp4.userid
            row.thursday.teaName = tmp4.realname
            row.thursday.popoverVisible = false
          } else {
            row.thursday.subjectName = ''
            row.thursday.teaId = ''
            row.thursday.teaName = ''
          }
          break;
        case 5:
          if (row.friday.subjectId !== '') {
            let tmp5 = this.substituteTeaList.find(item => item.subjectid === row.friday.subjectId)
            row.friday.subjectName = tmp5.subject_name
            row.friday.teaId = tmp5.userid
            row.friday.teaName = tmp5.realname
            row.friday.popoverVisible = false
          } else {
            row.friday.subjectName = ''
            row.friday.teaId = ''
            row.friday.teaName = ''
          }
          break;
        case 6:
          if (row.saturday.subjectId !== '') {
            let tmp6 = this.substituteTeaList.find(item => item.subjectid === row.saturday.subjectId)
            row.saturday.subjectName = tmp6.subject_name
            row.saturday.teaId = tmp6.userid
            row.saturday.teaName = tmp6.realname
            row.saturday.popoverVisible = false
          } else {
            row.saturday.subjectName = ''
            row.saturday.teaId = ''
            row.saturday.teaName = ''
          }
          break;
        case 7:
          if (row.sunday.subjectId !== '') {
            let tmp7 = this.substituteTeaList.find(item => item.subjectid === row.sunday.subjectId)
            row.sunday.subjectName = tmp7.subject_name
            row.sunday.teaId = tmp7.userid
            row.sunday.teaName = tmp7.realname
            row.sunday.popoverVisible = false
          } else {
            row.sunday.subjectName = ''
            row.sunday.teaId = ''
            row.sunday.teaName = ''
          }
          break;
      }
      this.substituteTeaList = []
    },

    //清除数据
    clearData() {
      this.activeClassroomInfo = {
        // 教室id
        id: '',
        // 教师名称
        title: '',
        // 学校id
        schoolId: '',
        // 班级id
        classId: '',
      }
      this.tableDataList = []
    },

    // 检测数据
    isCheck() {
      // 数据预处理
      let filterList = []
      let tmpJson = JSON.stringify(this.tableDataList)
      let tmpTableDataList = JSON.parse(tmpJson)
      if (tmpTableDataList.length > 0) {
        filterList = tmpTableDataList.filter((item, index) => !((item.startTime === '' && item.endTime === '') && (item.monday.subjectId === '' && item.tuesday.subjectId === ''
            && item.wednesday.subjectId === '' && item.thursday.subjectId === '' && item.friday.subjectId === '' && item.saturday.subjectId === '' && item.sunday.subjectId === '')))
        filterList.map((item, index) => {
          item.num = index + 1
          return item
        });
      }

      if (filterList.length > 0) {
        let res = true
        let msg = ''
        filterList.forEach(item => {
          if (!item.startTime || !item.endTime) {
            msg += `${item.num} 节的开始时间或结束时间不能为空\t`
            res = false
          }
        })
        if (!res) {
          this.$message.warning(msg)
          return false
        }
      }

      return true
    },

    // 取消
    cancel() {
      this.dialogVisible = false
      this.clearData()
      this.$emit('refresh-class-course-state')
    },

    // 提交数据
    submitData() {
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
        classRoomId: this.activeClassroomInfo.id
      }
      if (this.isCheck()) {
        let resList = this.handleSaveData()
        if (resList.length > 0) {
          setClassCourseTableApi({setClassCourseTableJson: JSON.stringify(resList)}).then((data) => {
            this.$message.success('保存成功')
            this.getClassCourseTableList(params)
          }).catch(function (error) {
            this.$message.error(error.message);
          })
        } else {
          if (this.delIds.length > 0) {
            delClassCourseTableApi({ids: this.delIds}).then((data) => {
              this.$message.success("节次课程删除成功")
              this.getClassCourseTableList(params)
            }).catch(function (error) {
              this.$message.error(error.message);
            })
          } else {
            this.$message.success('暂未配置课表，请配置课表后才可保存')
          }
        }
      }
    },

    // 数据处理
    handleSaveData() {
      // 数据复制
      let listJson = JSON.stringify(this.tableDataList)
      let list = JSON.parse(listJson)
      // 过滤后的数据
      let filterList = []
      // 数据预处理
      if (list.length > 0) {
        filterList = list.filter((item, index) => !((item.startTime === '' && item.endTime === '') && (item.monday.subjectId === '' && item.tuesday.subjectId === ''
            && item.wednesday.subjectId === '' && item.thursday.subjectId === '' && item.friday.subjectId === '' && item.saturday.subjectId === '' && item.sunday.subjectId === '')))
        filterList.map((item, index) => {
          item.num = index + 1
          return item
        });
      }
      // 返回数据
      let resList = []
      // 数据生成
      filterList.forEach(item => {
        if (item.monday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.id,
            creatorName: this.$store.state.user.realname,
            teaId: item.monday.teaId,
            teaName: item.monday.teaName,
            classId: item.monday.classId,
            className: item.monday.className,
            subjectId: item.monday.subjectId,
            subjectName: item.monday.subjectName,
            num: item.num,
            week: 1,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
        if (item.tuesday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: item.tuesday.teaId,
            teaName: item.tuesday.teaName,
            classId: item.tuesday.classId,
            className: item.tuesday.className,
            subjectId: item.tuesday.subjectId,
            subjectName: item.tuesday.subjectName,
            num: item.num,
            week: 2,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
        if (item.wednesday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: item.wednesday.teaId,
            teaName: item.wednesday.teaName,
            classId: item.wednesday.classId,
            className: item.wednesday.className,
            subjectId: item.wednesday.subjectId,
            subjectName: item.wednesday.subjectName,
            num: item.num,
            week: 3,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
        if (item.thursday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: item.thursday.teaId,
            teaName: item.thursday.teaName,
            classId: item.thursday.classId,
            className: item.thursday.className,
            subjectId: item.thursday.subjectId,
            subjectName: item.thursday.subjectName,
            num: item.num,
            week: 4,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
        if (item.friday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: item.friday.teaId,
            teaName: item.friday.teaName,
            classId: item.friday.classId,
            className: item.friday.className,
            subjectId: item.friday.subjectId,
            subjectName: item.friday.subjectName,
            num: item.num,
            week: 5,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
        if (item.saturday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: item.saturday.teaId,
            teaName: item.saturday.teaName,
            classId: item.saturday.classId,
            className: item.saturday.className,
            subjectId: item.saturday.subjectId,
            subjectName: item.saturday.subjectName,
            num: item.num,
            week: 6,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
        if (item.sunday.subjectId.length) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: item.sunday.teaId,
            teaName: item.sunday.teaName,
            classId: item.sunday.classId,
            className: item.sunday.className,
            subjectId: item.sunday.subjectId,
            subjectName: item.sunday.subjectName,
            num: item.num,
            week: 7,
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }

        if ((!item.monday.subjectId && !item.tuesday.subjectId && !item.wednesday.subjectId && !item.thursday.subjectId && !item.friday.subjectId
            && !item.saturday.subjectId && !item.sunday.subjectId) && item.startTime && item.endTime) {
          let tmp = {
            schoolId: item.schoolId,
            classroomId: item.classroomId,
            roomClassId: item.roomClassId,
            creatorId: this.$store.state.user.userId,
            creatorName: this.$store.state.user.name,
            teaId: '',
            teaName: '',
            classId: '',
            className: '',
            subjectId: '',
            subjectName: '',
            num: item.num,
            week: '',
            startTime: item.startTime,
            endTime: item.endTime
          }
          resList.push(tmp)
        }
      })
      return resList
    },

    // 检测行是否存在数据
    isRowExistData(row) {
      return !(row.startTime === '' && row.endTime === '' && row.monday.subjectId === ''
          && row.tuesday.subjectId === '' && row.wednesday.subjectId === '' && row.thursday.subjectId === '' && row.friday.subjectId === '' && row.saturday.subjectId === '' && row.sunday.subjectId === '');
    },

    // 清除行数据
    clearRow(row) {
      row.startTime = ''
      row.endTime = ''
      row.monday.classId = ''
      row.tuesday.classId = ''
      row.wednesday.classId = ''
      row.thursday.classId = ''
      row.friday.classId = ''
      row.saturday.classId = ''
      row.sunday.classId = ''
      row.monday.subjectId = ''
      row.tuesday.subjectId = ''
      row.wednesday.subjectId = ''
      row.thursday.subjectId = ''
      row.friday.subjectId = ''
      row.saturday.subjectId = ''
      row.sunday.subjectId = ''
    },

    // 添加教室
    addOrEditClassroom(update, item) {
      this.classroomDialogUpdate = update
      if (update) {
        this.classroomForm = JSON.parse(JSON.stringify(item))
      }
      this.classroomDialogVisible = true
    },

    /**
     * 删除教室
     * @param item 教室信息
     */
    deleteClassroom(item) {
      this.$confirm('此操作将永久删除该教室, 是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        await delClassRoomApi({classRoomId: item.id}).then(() => {
          this.$message.success('删除成功')
          this.$emit('refresh-classroom-list')
          Object.assign(this.activeClassroomInfo, {
            // 教室id
            id: '',
            // 教师名称
            title: '',
            // 学校id
            schoolId: '',
            // 班级id
            classId: '',
          })
        }).catch((error) => {
          this.$message.error(error.message);
        })
        if (this.classroomList.length > 0) {
          this.findCurriculumData(this.classroomList[0], 0)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },

    // 清除教室数据
    clearClassroomData() {
      this.classroomForm.id = ''
      this.classroomForm.title = '未来教室'
      this.classroomForm.schoolId = ''
      this.classroomForm.classId = ''
    },

    // 关闭教室弹框
    closeClassroom() {
      this.clearClassroomData()
      this.classroomDialogVisible = false
    },

    // 保存教室数据
    saveClassroom() {
      this.$refs['classroomFormRef'].validate((valid) => {
        if (!valid) {
          return false
        }
        const params = {
          id: this.classroomForm.id,
          title: this.classroomForm.title,
          schoolId: this.classroomForm.schoolId ? this.classroomForm.schoolId : this.schoolId,
          classId: this.classroomForm.classId
        }
        saveClassRoomApi(params).then((res) => {
          this.$message.success(this.classroomForm.id ? '编辑成功' : '保存成功')
          let tmp = {
            id: res,
            title: params.title,
            schoolId: params.schoolId,
            classId: params.classId
          }
          this.findCurriculumData(tmp)
          this.$emit('refresh-classroom-list')
          this.classroomDialogVisible = false
          this.clearClassroomData()
        }).catch(function (error) {
          this.$message.error(error.message)
          this.clearClassroomData()
        })
      })
    },

    // 获取班级列表
    async getClassList() {
      let _this = this;
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
        classType: this.classParams.classType,
        page: this.classParams.page,
        limit: this.classParams.limit
      }

      await getClassListApi(params).then((res) => {
        this.classParams.page = res.page;
        this.classParams.totalRows = res.total_rows;
        this.classParams.pageCount = res.page_count
        if (this.classParams.page === 1) {
          this.classList = res.rows
        } else {
          this.classList = [...this.classList, ...res.rows]
        }
        if (this.classList.length === this.classParams.totalRows) {
          this.classParams.stopLoading = true
        }
      }).catch(function (error) {
        _this.$message.error(error.message)
      })
    },

    // 滚动条事件
    loadMore() {
      if (!this.classParams.stopLoading) {
        this.classParams.page += 1
        this.getClassList();
      }
    },

    /**
     * 获取授课教师
     * @param item 班级id
     * @return {*[]}
     */
    async getTeacherList(item) {
      let params = {
        schoolId: this.schoolId === "0" ? "" : this.schoolId,
        classId: item
      }
      if (item) {
        await getTeacherListByClassId(params).then((data) => {
          this.substituteTeaList = data
        }).catch(function (error) {
          this.$message.error(error.message);
        })
      } else {
        this.substituteTeaList = []
      }
    },

    // 不存在时显示
    optionNotFound(classId) {
      if (classId.length > 0) {
        return !this.classList.some((option) => option.id === classId)
      } else {
        return false
      }
    },

    // 时间弹框气泡重新定位
    handleClickPopover(tablePopoverRef) {
      const ratio = window.devicePixelRatio
      if (ratio > 1) {
        // 鼠标点击触发
        const popover = this.$refs[tablePopoverRef]
        let timer = setTimeout(() => {
          const {popperElm} = popover
          let left = popperElm.style.left.replace('px', '') * ratio + 35 + 'px'
          let top = popperElm.style.top.replace('px', '') * ratio + 20 + 'px'
          popover.popperElm.style.left = left
          popover.popperElm.style.top = top
          clearTimeout(timer)
        }, 50)
      }
    },

    // 周弹框气泡重新定位
    handleClickWeekPopover(tablePopoverRef) {
      const ratio = window.devicePixelRatio
      if (ratio > 1) {
        // 鼠标点击触发
        const popover = this.$refs[tablePopoverRef]
        let timer = setTimeout(() => {
          const {popperElm} = popover
          let left = popperElm.style.left.replace('px', '') * ratio + 70 + 'px'
          let top = popperElm.style.top.replace('px', '') * ratio + 80 + 'px'
          popover.popperElm.style.left = left
          popover.popperElm.style.top = top
          clearTimeout(timer)
        }, 50)
      }
    },

    // 选择班级定位
    focusFormClassSelect(item) {
      const ratio = window.devicePixelRatio
      if (ratio > 1) {
        // 鼠标点击触发
        const popover = this.$refs[`formClassSelect${item}Ref`]
        let timer = setTimeout(() => {
          const {popperElm} = popover
          let left = popperElm.style.left.replace('px', '') * ratio + 'px'
          let top = popperElm.style.top.replace('px', '') * ratio + 'px'
          popover.popperElm.style.left = left
          popover.popperElm.style.top = top
          clearTimeout(timer)
        }, 140)
      }
    },

    // 选择学科定位
    focusFormSubjectSelect(item) {
      const ratio = window.devicePixelRatio
      if (ratio > 1) {
        // 鼠标点击触发
        const popover = this.$refs[`formSubjectSelect${item}Ref`]
        let timer = setTimeout(() => {
          const {popperElm} = popover
          let left = popperElm.style.left.replace('px', '') * ratio + 'px'
          let top = popperElm.style.top.replace('px', '') * ratio + 'px'
          popover.popperElm.style.left = left
          popover.popperElm.style.top = top
          clearTimeout(timer)
        }, 140)
      }
    }
  },

  watch: {
    'tableDataList': {
      deep: true,
      handler(newVal) {
        // 假设填写了上一行数据则自动添加空行
        if (newVal.length <= 20 && this.isRowFilled(newVal[newVal.length - 1])) {
          this.addOrEdit()
        }
        // 删除的课表ids
        if (newVal.length) {
          let filterList = newVal.filter((item) => (item.startTime === '' && item.endTime === '') && (!item.monday.subjectId && !item.tuesday.subjectId && !item.wednesday.subjectId && !item.thursday.subjectId || !item.friday.subjectId || !item.saturday.subjectId || !item.sunday.subjectId))
          let setIds = new Set()
          filterList.forEach(item => {
            if (item.id > 0) {
              setIds.add(item.id)
            }
            if (item.monday.id > 0) {
              setIds.add(item.monday.id)
            }
            if (item.tuesday.id > 0) {
              setIds.add(item.tuesday.id)
            }
            if (item.wednesday.id > 0) {
              setIds.add(item.wednesday.id)
            }
            if (item.thursday.id > 0) {
              setIds.add(item.thursday.id)
            }
            if (item.friday.id > 0) {
              setIds.add(item.friday.id)
            }
            if (item.saturday.id > 0) {
              setIds.add(item.saturday.id)
            }
            if (item.sunday.id > 0) {
              setIds.add(item.sunday.id)
            }
          })
          this.delIds = Array.from(setIds).toString()
        }
      }
    },
  },

  directives: {
    'el-select-loadmore': {
      bind(el, binding) {
        // 下拉框下拉的框
        const SELECT_WRAP_DOM = el.querySelector(
            '.el-select-dropdown .el-select-dropdown__wrap'
        );
        // 增加滚动监听，
        SELECT_WRAP_DOM.addEventListener('scroll', function () {
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value()
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.el-dialog.custom-dialog-class) {
  background-color: #000734;
  background-image: url("../../assets/images/nanjingdataboard/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  .el-dialog__header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: unset;
  }

  .el-dialog__body {
    width: 100%;
    padding-top: unset;
    padding-bottom: unset;
    height: 575px;
  }

  .el-dialog__footer {
    width: 100%;
    height: 70px;
    padding: unset;
  }
}

.custom-dialog-header {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    position: relative;
    width: 100%;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
    text-align: left;
    //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

    span:nth-of-type(1) {
      display: inline-block;
      transform: translateY(2px);
      width: 8px;
      height: 18px;
      background: #06D6F8;
      border-radius: 4px;
      margin-left: 20px;
    }

    span:nth-of-type(2) {
      width: 120px;
      height: 20px;
      font-family: Microsoft YaHei;
      margin-left: 10px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
  }

  .close {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;

    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}

.dialog-body {
  position: relative;
  width: 100%;
  height: 100%;

  .left {
    position: relative;
    width: 200px;
    height: 100%;
    float: left;

    .left-top {
      position: relative;
      width: 100%;
      height: 545px;
      background-image: url("../../assets/images/nanjingdataboard/bg-zuo.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      padding-left: 15px;
      padding-right: 15px;
      padding-top: 15px;

      :deep(.el-select) {
        width: 100%;
        color: #8BA4E7;

        margin-right: 10px;

        .el-select__caret {
          line-height: 32px;
          color: #8BA4E7;
        }

        .el-input__inner {
          height: 32px !important;
          background: rgba(13, 33, 94, 0.43);
          border: 1px solid #4C76BA;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          border-radius: 2px;
          color: #8BA4E7;
          line-height: 32px;
          text-align: center;
        }

        .popper__arrow {
          display: none;
        }
      }

      .classroom-list-title {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #4C76BA;
        border-radius: 5px;

        span {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
        }
      }

      .left-top-list {
        position: relative;
        width: 100%;
        margin-top: 10px;
        height: calc(100% - 80px);
        overflow-y: auto;
        font-size: 16px;

        ul {
          li {
            position: relative;
            padding-top: 10px;
            padding-bottom: 10px;
            color: #8BA4E7;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              margin-left: 10px;
              width: 15px;
              height: 15px;
            }

            .classroom-delete {
              position: absolute;
              top: 5px;
              right: 5px;
              width: 16px;
              display: none;
              color: #ff5762;
            }
          }

          li:hover {
            cursor: pointer;
            background-color: rgba(76, 118, 186, 0.2);
          }

          li:hover .classroom-delete {
            display: block;
          }

          .li-active {
            background-color: rgba(76, 118, 186, 0.2);
          }

          .add-classroom {
            margin-top: 20px;
            width: 100%;
            background: rgba(76, 118, 186, 0.5);
            border-radius: 20px;
            border: 1px solid #06D6F8;

            span {
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 16px;
              color: #06D6F8;

            }
          }

          .add-classroom:hover {
            background: rgba(76, 118, 186, 0.5);
          }
        }
      }
    }

    //.left-bottom {
    //  position: relative;
    //  width: 100%;
    //  height: 30px;
    //  line-height: 30px;
    //
    //  span {
    //    font-family: Microsoft YaHei;
    //    font-weight: 400;
    //    font-size: 13px;
    //    color: #C7D5F2;
    //  }
    //}
  }

  .right {
    position: relative;
    width: calc(100% - 210px);
    margin-left: 10px;
    height: 100%;
    float: left;
    box-sizing: border-box;
    background-image: url("../../assets/images/nanjingdataboard/bg-you.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    padding: 40px 30px 0;

    .el-table-custom-span:hover {
      cursor: pointer;
    }

    .add-span {
      font-weight: bold;
      font-size: 18px;
    }

    .no-data {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;

      span {
        font-weight: bold;
        color: #fff;
        font-size: 30px;
      }
    }

    :deep(.el-table) {
      background-color: transparent !important;
      margin: 0;
      height: calc(100% - 20px);

      .el-table__body-wrapper {
        max-height: calc(100% - 67px);
        overflow-y: auto;
      }
    }

    :deep(.el-table::before) {
      background-color: transparent !important;
    }

    :deep(.el-table .el-table__header-wrapper) {
      background-color: rgba(76, 118, 186, 0.2);
      border-radius: 10px 10px 2px 2px;
      color: #8BA4E7;
    }

    :deep(.el-table tr) {
      background-color: rgba(76, 118, 186, 0);
    }

    :deep(.el-table th) {
      background-color: rgba(76, 118, 186, 0);
      color: #8BA4E7;
    }

    :deep(.el-table th.el-table__cell.is-leaf) {
      border-bottom: unset !important;
    }

    :deep(.el-table td.el-table__cell) {
      border-bottom: unset !important;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #C7D5F2;
      border-right: 1px solid #626F96;
      border-top: 1px solid #626F96;
      //border: 1px solid #626F96;
    }

    // 空数据样式
    :deep(.el-table__empty-block) {
      border-top: 1px solid #626F96;
    }

    :deep(.el-table .el-table__body-wrapper) {
      margin-top: 20px;
      border-top: unset;
      border-right: 1px solid #626F96;
      border-left: 1px solid #626F96;
      border-bottom: 1px solid #626F96;
    }

    :deep(.el-table .el-table__body ) {
      tr:hover > td {
        background-color: rgba(76, 118, 186, 0.2) !important;
      }
    }

    :deep(.el-date-editor.el-input) {
      width: auto;

      .el-input__icon {
        display: none;
      }

      .el-input__inner {
        width: 100%;
        padding: 0;
        text-align: center;
      }
    }

    :deep(.el-empty__image svg) {
      display: none;
    }

    :deep(.el-select) {
      .el-input__inner {
        width: 100%;
        padding-left: 10px;
        padding-right: 20px;
      }
    }
  }
}

.dialog-footer {
  position: relative;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-button {
    margin-left: 20px;
  }

  .el-button:nth-of-type(2) {
    background: #041957;
    border-radius: 4px;
    border: 1px solid #4C76BA;
    color: #4C76BA;
  }
}

.el-message {
  white-space: normal;
  word-break: break-all;
  max-width: 410px;
}

:deep(.el-dialog.classroom-dialog) {
  margin-top: 30vh !important;
  height: 320px;
  border: 1px solid #3B5984;
  background-image: url("../../assets/images/nanjingdataboard/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  .el-dialog__header {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: unset;
  }

  .el-dialog__body {
    width: 100%;
    padding-top: unset;
    padding-bottom: unset;
  }

  .el-dialog__footer {
    width: 100%;
    height: 70px;
    padding: unset;
  }

  .classroom-dialog-header {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      position: relative;
      width: 100%;
      font-family: Microsoft YaHei, serif;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
      text-align: left;
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;

      span:nth-of-type(1) {
        display: inline-block;
        transform: translateY(2px);
        width: 8px;
        height: 18px;
        background: #06D6F8;
        border-radius: 4px;
        margin-left: 20px;
      }

      span:nth-of-type(2) {
        width: 120px;
        height: 20px;
        font-family: Microsoft YaHei;
        margin-left: 10px;
        font-weight: bold;
        font-size: 20px;
        color: #FFFFFF;
        text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
        //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
        //-webkit-background-clip: text;
        //-webkit-text-fill-color: transparent;
      }
    }

    .close {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;

      img {
        width: 15px;
        height: 15px;
        cursor: pointer;
      }
    }
  }

  .classroom-dialog-body {
    height: 200px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-form-item__label {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #172F71;
      border-radius: 4px;
      opacity: 0.6;

      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #B3C8FF;
    }

    .el-form-item__content {
      padding-left: 20px;

      .el-input, .el-input__inner {
        background: #172F71;
        border-radius: 4px;
        border: 1px solid #4C76BA;
        text-align: center;
        color: #B3C8FF;
      }
    }

    .bind-class-select-dropdown {
      text-align: center;
      left: unset !important;
      top: unset !important;

      .popper__arrow {
        //display: none;
        left: 50% !important;
        color: #8BA4E7;
      }

      .el-select-dropdown__item {
        color: #8BA4E7;
        font-size: 15px;
      }

      .el-select-dropdown__item.hover {
        background-color: rgba(76, 118, 186, 0.3);
      }
    }
  }

  .classroom-dialog-footer {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

</style>
<style lang="scss">
// 课表设置时间弹窗
.el-popover.table-custom-popover {
  padding: 0 !important;

  .el-date-editor.el-input {
    width: 158px;
  }

  .el-input__inner {
    border: 1px solid #ffff;
    text-align: center;
    height: 32px;
  }

  .custom-time-picker {
    position: absolute !important;
    top: 30px !important;
  }
}

// 表设置学科弹框
.el-popover.table-custom-select-popover {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 30px 0 0;

  .el-input__inner {
    width: 160px;
    //border: 1px solid #ffff;
    text-align: center;
    font-size: 16px;
    height: 32px;
  }

  .el-input__icon {
    height: unset;
  }
}

</style>
